/**
 * Right Drawer Theme Access
 *
 * Makes the theme object from the right drawer Vue component globally accessible
 * by finding the Vue instance in the DOM and exposing its theme property as window.theme.
 *
 * This allows direct access to drawer-specific methods like updateCartDrawer
 * from custom components outside the Vue ecosystem.
 */
(function () {
  // Set a maximum number of retry attempts to prevent infinite loops
  const MAX_RETRY_ATTEMPTS = 10;
  let retryCount = 0;

  /**
   * Attempts to find and expose the theme object from the right drawer Vue component
   */
  function exposeRightDrawerTheme() {
    // Stop trying after maximum attempts
    if (retryCount >= MAX_RETRY_ATTEMPTS) {
      console.warn('Could not find Vue theme object after maximum retry attempts');
      return;
    }

    retryCount++;
    const rightDrawerVue = document.querySelector('.right-drawer-vue');

    if (!rightDrawerVue) {
      setTimeout(exposeRightDrawerTheme, 500);
      return;
    }

    if (!rightDrawerVue.__vue__) {
      setTimeout(exposeRightDrawerTheme, 500);
      return;
    }

    try {
      const vueInstance = rightDrawerVue.__vue__;

      if (!vueInstance.$children || vueInstance.$children.length === 0) {
        setTimeout(exposeRightDrawerTheme, 500);
        return;
      }

      const drawerComponent = vueInstance.$children[0];

      if (!drawerComponent || !drawerComponent.theme) {
        setTimeout(exposeRightDrawerTheme, 500);
        return;
      }

      window.theme = window.theme || {};
      window.theme = { ...window.theme, ...drawerComponent.theme };
      window.theme.rightDrawer = drawerComponent;

      document.documentElement.dispatchEvent(
        new CustomEvent('theme:ready', {
          detail: {
            theme: window.theme,
            rightDrawer: drawerComponent,
          },
        })
      );
    } catch (error) {
      console.error('Error accessing Vue component:', error);
      setTimeout(exposeRightDrawerTheme, 1000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', exposeRightDrawerTheme);
  } else {
    exposeRightDrawerTheme();
  }
})();
